import * as React from 'react';
import { Input, Col, Switch, Select } from 'antd';
const { Option } = Select;

interface iState {
    switchState: boolean;
    typeValue: any;
}

export default class InsertSwitch extends React.Component<any, iState> {

    state: iState = {
        switchState: this.props.initialValue,
        typeValue: {}
    };

    // change 事件处理
    changeHandler = (e: any, options: any) => {
        let { typeValue, switchState } = this.state;
        const { typeList } = this.props;
        const { onChange } = this.props.switchConfig;
        let formatTypeValue = typeValue || {};
        if (!switchState) {
            for (const key in typeList) {
                Object.assign(formatTypeValue, { [typeList[key].value]: e });
            }
        } else {
            Object.assign(formatTypeValue, { [options.props.className]: e });
        }
        this.setState({
            typeValue: formatTypeValue
        });
        onChange && onChange(this.state);
    };

    switchChangeHandler = (checked: boolean) => {
        const { switchConfig, typeList } = this.props;
        let typeValue = {};
        for (const key in typeList) {
            Object.assign(typeValue, { [typeList[key].value]: '1' });
        }
        this.setState({
            switchState: checked,
            typeValue
        }, switchConfig.onChange && switchConfig.onChange({
            switchState: checked,
            typeValue
        }));
    }
    initData = () => {
        const { typeList, initialValue } = this.props;
        let typeValue = {};
        for (const key in typeList) {
            Object.assign(typeValue, { [typeList[key].value]: typeList[key].initialValue });
        }
        this.setState({
            switchState: initialValue,
            typeValue
        });
    }
    componentDidMount() {
        this.initData();
    }
    UNSAFE_componentWillReceiveProps() {
        const { editing } = this.props.switchConfig;
        editing && this.initData();
    }
    render() {
        const { typeList, disabled, initialValue, switchConfig, options, tips } = this.props;
        const { switchState, typeValue } = this.state;
        const { editing } = switchConfig;
        return (
            <Input.Group>
                <Col span={6} style={{ display: 'flex', flexDirection: 'row', position: 'relative' }}>
                    {editing && <Switch style={{ position: 'absolute', left: -35, top: 5 }} checkedChildren={switchConfig.title} unCheckedChildren={switchConfig.title} size="small" disabled={disabled} defaultChecked={initialValue} checked={switchState} onChange={this.switchChangeHandler} />}
                    <div style={{ flex: '1' }}>
                        {typeList.map((list: any) => {
                            {
                                return (list.switch == switchState) && <div key={list.value} style={{ height: 30, marginBottom: 16, paddingTop: 5 }}>{list.label}</div>;
                            }

                        })
                        }
                    </div>
                </Col>
                <Col span={8}>
                    {typeList.map((list: any) => {
                        {
                            {
                                return (list.switch == switchState) && <div key={list.value} style={{ marginBottom: 16, height: 30 }} >
                                    <div>
                                        <Select disabled={disabled} style={{ width: 120 }} defaultValue={list.initialValue} value={typeValue[list.value]} onChange={this.changeHandler}>
                                            {

                                                options.map((item: any) => {
                                                    return <Option key={item.value} className={list.value} value={item.value}>{item.label}</Option>;
                                                })
                                            }
                                        </Select>

                                    </div>
                                </div>;

                            }
                        }

                    })

                    }

                </Col>
                <Col span={10}>
                    <div style={{ marginLeft: 24 }}>{tips}</div>
                </Col>

            </Input.Group>
        );
    }
}
